import React from "react";
import { FormattedMessage } from "react-intl";
import { StaticFooter } from "../Common";
import LanguageSelectionDropDown from "../LanguageDropDown";
import { SupplierLogoContainer } from "../MainApp";
import * as DOMPurify from 'dompurify';
import { PaymentStatus } from "./";
import {myGlobals, myUtilities} from "../../Utils";
import TrifectaCover from "../Common/TrifectaCover";
import RetryContainer from "./RetryContainer";
import { connect } from "react-redux";
import Tick from "../../Images/tick.svg";

class PaymentCompleted extends React.Component {
  paymentCompletedSuccessfully = () => {
    return (
      <React.Fragment>
        <img
          className="tick-image"
          src={Tick}
        />
        <br />
        <br />
        <div className="payment-complete-div">
          {myUtilities.accountSpecificLanguage(
			  "payment.success",
			  "Payment Successful"
		  )}
          !
        </div>
        <br />
		{this.props.retryReceipt.receiptFailCount < 3 && myUtilities.accountSpecificLanguage(
			  "payment.success.receipt.warning",
			  "Please wait for payment receipt to be downloaded before closing this page. Disable any pop-up blockers in order to view payment receipt in new tab."
		  )}
        <RetryContainer/>
      </React.Fragment>
    );
  };
  getPaymentComplete = () => {
		
	if(this.props.isDirectDebit){
		return (
			<div className="centered-container">
			<PaymentStatus
				directDebitResponse={this.props.directDebitResponse}
				isDirectDebit
			/>
			{this.paymentCompletedSuccessfully()}
			</div>
		);
		}else if (this.props.isAch) {
	      return (
	        <div className="centered-container">
	          <PaymentStatus />
	          {this.paymentCompletedSuccessfully()}
	        </div>
	      );
	    } else {
	      return (
	        <div className="centered-container">
	          <PaymentStatus
	            creditCardResponse={this.props.creditCardResponse}
	            isCreditCard
	          />
	          {this.paymentCompletedSuccessfully()}
	        </div>
	      );
	    }
	  };
	  renderTrifectaTheme = () => {
	    return (
	      <>
	        <SupplierLogoContainer />
	        <LanguageSelectionDropDown />
	        <div className="static-page-contain">{this.getPaymentComplete()}</div>
	        <StaticFooter parent="footer-pay-complete" />
	      </>
	    );
	  };
  render() {
	    return (myGlobals.currentTheme === "trifectaTheme.css" || myGlobals.currentTheme === 'modernUX.css')
	      ? <TrifectaCover> {this.getPaymentComplete()} </TrifectaCover>
	      : this.getPaymentComplete();
	  }
}

const mapStateToProps = (state) => ({
	retryReceipt: state.retryReceipt,
  });
  
  
export default connect(mapStateToProps, null)(PaymentCompleted);

